export default function serializeArray(form) {
  let field;
  let length;
  const serializedArray = [];

  if (typeof form === 'object' && form.nodeName === 'FORM') {
    const elementLength = form.elements.length;

    for (let i = 0; i < elementLength; i += 1) {
      field = form.elements[i];

      if (
        field.name &&
        !field.disabled &&
        field.type !== 'file' &&
        field.type !== 'reset' &&
        field.type !== 'submit' &&
        field.type !== 'button'
      ) {
        if (field.type === 'select-multiple') {
          ({ length } = form.elements[i].options);

          for (let j = 0; j < length; j += 1) {
            if (field.options[j].selected)
              serializedArray[serializedArray.length] = {
                name: field.name,
                value: field.options[j].value
              };
          }
        } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
          serializedArray[serializedArray.length] = { name: field.name, value: field.value };
        }
      }
    }
  }
  return serializedArray;
}
